import { render, staticRenderFns } from "./SendDocumentForm.vue?vue&type=template&id=3543d8ee&scoped=true&"
import script from "./SendDocumentForm.vue?vue&type=script&lang=js&"
export * from "./SendDocumentForm.vue?vue&type=script&lang=js&"
import style0 from "./SendDocumentForm.vue?vue&type=style&index=0&id=3543d8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3543d8ee",
  null
  
)

export default component.exports